import { render, staticRenderFns } from "./StudentShell.vue?vue&type=template&id=b28813d2&scoped=true"
import script from "./StudentShell.vue?vue&type=script&lang=js"
export * from "./StudentShell.vue?vue&type=script&lang=js"
import style0 from "./StudentShell.vue?vue&type=style&index=0&id=b28813d2&prod&scoped=true&lang=scss"
import style1 from "./StudentShell.vue?vue&type=style&index=1&id=b28813d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28813d2",
  null
  
)

export default component.exports